import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';
import { Alert } from 'react-bootstrap';
import { getSubscriptionStatus } from '../../helpers';

const AlertMessage = ({ subscription }) => {

  const [subscriptionInfo, setSubscriptionInfo] = useState({ status: 'inactive', daysRemaining: 0 });
  const startDate = moment.unix(subscription?.current_period_start).format('MMMM Do, YYYY');
  const endDate = moment.unix(subscription?.current_period_end).format('MMMM Do, YYYY');
  const { status, daysRemaining } = subscriptionInfo;

  useEffect(() => {
    const result = getSubscriptionStatus(subscription, 7);
    setSubscriptionInfo(result);
  }, [subscription]);

  return (
    <div>
      {status === "free" && (
        <Alert variant="primary">
          You are using the Free Plan with limited features. <Link className="fw-600" to="/subscriptions">Upgrade for more!</Link>
        </Alert>
      )}
      {status === "active" && (
        <Alert variant="success">
          Your subscription is active from {startDate} to {endDate}.
        </Alert>
      )}
      {status === "warning" && (
        <Alert variant="warning">
          Your subscription will expire in {daysRemaining} day(s). Please renew soon.
        </Alert>
      )}
      {status === "expired" && (
        <Alert variant="danger">
          Your subscription has expired. Please renew to continue using the service.
        </Alert>
      )}
    </div>
  );
};

export default AlertMessage;
